import React, { useEffect } from 'react';
import { useAppSelector } from 'hooks';

import 'styles/App.css';

import { tponeUrl } from '~constants/tpone';

import { ToastProvider } from '~libs/toast';

import ToastHost from '~components/ToastHost';

import { selectForceRedirect } from '~main/selectors/login';

import AppRoutes from './components/AppRoutes';

const App: React.FC = () => {
  const REDIRECT_URL = tponeUrl;
  const forceRedirect = useAppSelector(selectForceRedirect);

  useEffect(() => {
    if (forceRedirect && REDIRECT_URL) {
      window.location.href = REDIRECT_URL;
    }
  }, [forceRedirect]);

  return (
    <ToastProvider>
      <AppRoutes />
      <ToastHost />
    </ToastProvider>
  );
};

export default App;
